import { render, staticRenderFns } from "./PurchaseOrderArchiveTable.vue?vue&type=template&id=0b0d0b52&scoped=true&"
import script from "./PurchaseOrderArchiveTable.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderArchiveTable.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrderArchiveTable.vue?vue&type=style&index=0&id=0b0d0b52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d0b52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VDataTable,VDivider,VSpacer})
